var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArgmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 100 100",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2471725915328"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43DD97",
    d: "M35 1c19,0 34,15 34,33 0,18 -15,33 -34,33 -4,0 -8,-1 -12,-2l-13 5 1 -13c-6,-6 -10,-14 -10,-23 0,-18 15,-33 34,-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M35 0c10,0 18,4 25,10 6,6 10,14 10,24 0,9 -4,18 -10,24 -7,6 -15,10 -25,10 -2,0 -4,0 -6,-1 -2,0 -4,-1 -6,-1l-13 5 -2 1 1 -2 1 -13c-3,-3 -6,-6 -7,-10 -2,-4 -3,-9 -3,-13 0,-10 4,-18 10,-24 7,-6 15,-10 25,-10zm23 12c-6,-6 -14,-10 -23,-10 -9,0 -17,4 -23,10 -6,5 -10,13 -10,22 0,4 1,8 3,12 1,4 4,7 7,10l0 0 0 1 -1 11 12 -4 0 -1 1 1c2,0 3,1 5,1 2,0 4,0 6,0 9,0 17,-3 23,-9 6,-6 10,-13 10,-22 0,-9 -4,-17 -10,-22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "22,38 28,45 46,20 48,21 28,47 28,47 27,47 20,40 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE765D",
    d: "M65 29c18,0 34,15 34,33 0,9 -4,17 -9,23l1 13 -14 -5c-4,2 -8,3 -12,3 -19,0 -35,-15 -35,-34 0,-18 16,-33 35,-33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M65 27c9,0 18,4 25,11 6,6 10,15 10,24 0,5 -1,9 -2,13 -2,4 -4,7 -7,10l1 13 0 2 -2 -1 -13 -5c-1,1 -4,2 -6,2 -2,1 -4,1 -6,1 -10,0 -19,-4 -26,-10 -6,-7 -10,-15 -10,-25 0,-9 4,-18 10,-24 7,-7 16,-11 26,-11zm23 12c-6,-6 -14,-9 -23,-9 -10,0 -18,3 -24,9 -6,6 -10,14 -10,23 0,9 4,17 10,23 6,6 14,10 24,10 2,0 4,-1 6,-1 2,0 4,-1 6,-2l0 0 1 0 11 5 -1 -12 0 0 1 -1c3,-3 5,-6 6,-10 2,-4 3,-8 3,-12 0,-9 -4,-17 -10,-23z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "52,50 65,62 76,51 77,52 66,63 78,75 76,76 65,65 52,77 51,75 63,63 50,51 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgmap);
export default __webpack_public_path__ + "static/media/argmap.b96ed4e5001bc1926f75bf33dcfefb54.svg";
export { ForwardRef as ReactComponent };